import React from 'react';

const CardBody = ({children, id, className, onClick, onScroll, ref}) => {
    return (
        <div id={id} className={["p-[10px]", className].join(" ")} onClick={onClick} onScroll={onScroll} ref={ref}>
            {children}
        </div>
    );
};

export default CardBody;